// extracted by mini-css-extract-plugin
export var about = "About-module--about--d6b51";